<template>
  <div>
    <b-container fluid>
      <b-row class="my-1">
        <b-col class="px-0 py-1 py-md-0 py-lg-0 py-xl-0" md="4">
          <b-pagination
            class="mx-auto my-auto default-table"
            v-model="currentPage"
            size="md"
            :per-page="perPage"
            :total-rows="totalRows"
          ></b-pagination>
        </b-col>
        <b-col class="px-0" md="8">
          <div class="d-flex align-items-center justify-content-between">
            <b-input class="w-50" type="text" size="md" v-model="filter" placeholder="検索"></b-input>
            <div class="d-flex align-items-end justify-content-between">
              <b-button class="float-right mx-1" variant="info" @click="handleUserListCSV">
                CSVダウンロード
              </b-button>
              <app-button class="default float-right" @click="handleUserListCreate">
                <slot name="create-button-label">登録</slot>
              </app-button>
            </div>
          </div>
        </b-col>
        <b-col class="px-0" md="4"></b-col>
      </b-row>
    </b-container>
    <b-table
      id="user-list"
      bordered
      small
      stacked="sm"
      striped
      :current-page="currentPage"
      :fields="[
        { key: '_name_', label: '名前', sortable: true, class: 'text-left' },
        { key: 'email', label: 'メールアドレス', sortable: true, class: 'text-left' },
        { key: '_button_', label: '' }
      ]"
      :filter="filter"
      :items="provider"
      :per-page="perPage"
    >
      <template v-slot:cell(_name_)="row">
        <span>{{ row.item.last_name }} {{ row.item.first_name }}</span>
      </template>
      <template v-slot:cell(_button_)="row">
        <b-button class="mx-1" size="sm" variant="link" @click="$emit('edit', row)">編集</b-button>
        <b-button class="mx-1" size="sm" variant="link" @click="handleUserListDelete(row)">削除</b-button>
      </template>
    </b-table>
    <b-modal
      id="user-delete-confirm-modal"
      :no-close-on-backdrop="true"
      title="確認"
      okTitle='OK'
      okVariant='default'
      cancelTitle='キャンセル'
      @ok="handleUserDeleteConfirmModalOk"
    >
      <p class="my-4">{{ confirmMessage }}</p>
    </b-modal>
  </div>
</template>

<script>
import AppButton from '@/components/presentationals/AppButton'

export default {
  name: 'UserList',

  components: {
    AppButton
  },

  props: {
    provider: Function,
    totalRows: Number,
    edit: Function,
    delete: Function
  },
  mounted() {
    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      this.initConfirmData()
    })
  },
  data() {
    return {
      filter: '',
      currentPage: 1,
      perPage: 20,
      confirmUserId: 0,
      confirmMessage: ''
    }
  },
  methods: {
    initConfirmData() {
      this.confirmUserId = 0
      this.confirmMessage = ''
    },
    handleUserListCreate(data) {
      this.$emit('create')
    },
    handleUserListDelete(data) {
      this.confirmUserId = data.item.id
      this.confirmMessage = `${data.item.last_name} ${data.item.first_name} (${data.item.email}) を削除します。`
      this.$bvModal.show('user-delete-confirm-modal')
    },
    handleUserDeleteConfirmModalOk() {
      this.$emit('delete', this.confirmUserId)
    },
    handleUserListCSV() {
      this.$emit('csv')
    }
  }
}
</script>
